import React from 'react';

import { StyleguideProps } from '../../../../types';

export const CheckList = ({ attributes: { children, ...attributes } }: StyleguideProps) => (
  <div {...attributes}>{children}</div>
);
